import BackgroundText from "../common/BackgroundText";
import ImageTitleWithDescription from "../common/ImageTitleWithDescription";
import { useNavigate } from "react-router-dom";
import { useInsightsData } from "../../hooks/useInsightsData";

export default function BlogSection() {
  const navigate = useNavigate();
  const { data } = useInsightsData();
  
  const handleKnowMore = (id: string) => {
    navigate(`/insights/blog/${id}`);
  };
  
  return (
    <div className="py-10 relative">
      <div className="container mx-auto px-5 sm:px-10 relative z-10">
        <BackgroundText text="Blog" />
        <ImageTitleWithDescription data={data.blogPosts} isBlog handleKnowMore={handleKnowMore} />
      </div>
    </div>
  );
}
